<template>
  <div class="marketplace">
    <div id="users-table" class="data-table">
      <div class="header" v-html="getHeader()">
      </div>
      <div v-for="(stat, index) in stats" v-bind:key="stat.month" class="row">
        <div class="cell id">{{stat.month}}</div>
        <div class="cell">
          {{stat.created}}
          <span class="stat" :class="stat.createdDiffClass">{{stat.createdDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.createdProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.completed}} ({{stat.percentage}}%)
          <span class="stat" :class="stat.completedDiffClass">{{stat.completedDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.completedProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.completedB2B}}
          <span class="stat" :class="stat.completedB2BDiffClass">{{stat.completedB2BDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.completedB2BProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.transactions}}
          <span class="stat" :class="stat.transactionsDiffClass">{{stat.transactionsDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.transactionsProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.transactionsB2B}}
          <span class="stat" :class="stat.transactionsB2BDiffClass">{{stat.transactionsB2BDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.transactionsB2BProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.revenue}}
          <span class="stat" :class="stat.revenueDiffClass">{{stat.revenueDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.revenueProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.revenueB2B}}
          <span class="stat" :class="stat.revenueB2BDiffClass">{{stat.revenueB2BDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.revenueB2BProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.transactionsPln}}
          <span class="stat" :class="stat.transactionsPlnDiffClass">{{stat.transactionsPlnDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.transactionsPlnProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.transactionsB2BPln}}
          <span class="stat" :class="stat.transactionsB2BPlnDiffClass">{{stat.transactionsB2BPlnDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.transactionsB2BPlnProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.revenuePln}}
          <span class="stat" :class="stat.revenuePlnDiffClass">{{stat.revenuePlnDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.revenuePlnProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.registered}}
          <span class="stat" :class="stat.registeredDiffClass">{{stat.registeredDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.registeredProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.registeredContacts}} <span v-if="stat.createdContacts">({{Math.round(stat.registeredContacts/stat.createdContacts * 100)}}%)</span>
          <span class="stat" :class="stat.registeredContactsDiffClass">{{stat.registeredContactsDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.registeredContactsProjected}}</span> -->
        </div>
        <div class="cell">
          {{stat.ltvLt}}
        </div>
        <div class="cell">
          {{stat.pros}}
          <span class="stat" :class="stat.prosDiffClass">{{stat.prosDiff}}</span>
          <!-- <span v-if="index === 0" class="stat projected">{{stat.prosProjected}}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="less">
  table td {
    border: 1px solid black;
    padding: 10px;
  }
  #users-table{
    grid-template-columns: auto auto auto auto auto auto auto auto auto auto auto auto auto auto auto;
  }
  .stat {
    font-size: 12px;
    // border: 1px solid black;
    display: block;
    float: right;
    margin-right: 10px;
  }
  .stat.negative {
    color: red
  }
  .stat.positive {
    color: green
  }
  .stat.projected {
    color: darkgoldenrod;
  }
  .cell {
    text-align: left;
    padding-left: 10px;
  }
</style>


<script>
import api from '../services/api';
import dayjs from 'dayjs';

function getMonthString(d) {
  const date = new Date(d._seconds * 1000);
  return (date.getFullYear() % 100);
}

export default {
  name: 'home',
  data: function() {
    return {
      stats: [],
      columns: [
        'Month',
        'Created C2C',
        'Completed C2C',
        'Completed B2B',
        'C2C EUR',
        'B2B EUR',
        'LT B2C REV',
        'LT B2B REV',
        'C2C PLN',
        'B2B PLN',
        'Rev PLN',
        'Reg users',
        'Reg contacts',
        'LTV LT',
        'Verified pros'
      ],
    }
  },
  methods: {
    getHeader() {
      return this.columns.map(column => '<div>' + column + '</div>').join('');
    },
  },
  created: async function() {
    const usersMap = await api.getUsers();
    const contacts = await api.getContacts();
    const users = Object.keys(usersMap).map(key => usersMap[key]);
    const pros = users
      .filter(u => (u.verified)).map((u, i) => ({...u, index: i})).sort(
      (u1, u2) => {
        const t1 = (u1.createdAt || {_seconds: 0})._seconds;
        const t2 = (u2.createdAt || {_seconds: 0})._seconds;
        return t2 - t1;
      }
    );
    const orders = (await api.getOrders()).filter(o => o.status != 'new' && o.status != 'confirmed' && o.status != 'new');
    const empty = {
      revenue: 0,
      revenueB2B: 0,
      registered: 0,
      registeredContacts: 0,
      createdContacts: 0,
      registeredLt: 0,
      pros: 0,
      created: 0,
      completed: 0,
      percentage: 0,
      transactions: 0,
      transactionsB2B: 0,
      transactionsB2BPln: 0,
      transactionsPln: 0,
      revenuePln: 0,
      completedB2B: 0,
      orderLifetimeC2cLt: 0
    };
    const startYear = 19;
    // const startMonth = 9;
    const endYear = parseInt(dayjs().format('YY'));
    // const endMonth = parseInt(dayjs().format('MM'));
    const months = {};
    for (let i = startYear; i <= endYear; i++) {
      // for (let j = (i === startYear ? startMonth : 1) ; j <= (i === endYear ? endMonth : 12); j++) {
        months[i] = {...empty, cohort: []};
      // }
    }
    // console.log(startYear, startMonth, endYear, endMonth, months);
    users.forEach(user => {
      if (user.email && user.createdAt) {
        const monthString = getMonthString(user.createdAt);
        months[monthString].registered += 1;
        if (user.phoneNumber && user.phoneNumber.startsWith('+370')) {
          months[monthString].registeredLt += 1;
          months[monthString].cohort.push(user.id);
        }
      }
    });
    contacts.forEach(contact => {
      if (contact.createdAt && !contact.inviteSecret) {
        // TODO: need to deal with case when created client is already a user. (but this stat will account it as unonboarded)
        const monthString = getMonthString(contact.createdAt);
        if (contact.onboardedAt) {
          months[monthString].registeredContacts += 1;
        }
        months[monthString].createdContacts += 1;
      }
    });
    orders.forEach(order => {
      if (order.createdAt) {
        const monthString = getMonthString(order.createdAt);
        if (!order.companyId) {
          months[monthString].created += 1;
        }
      }
      if (order.completedAt && order.status === 'completed' && order.worklog) {
        // TODO: laurynas assignes date according to task.datetime
        const monthString = getMonthString(order.completedAt);
        // TODO: need to consider refundsg
        // const cut = order.worklog.total * 0.2 - (order.worklog.discountAmount || 0);
        const cut = order.worklog.total * 0.2;
        let revenue = cut / 100;
        if (order.worklog.proTotal) {
          revenue = (order.worklog.total - order.worklog.proTotal) / 100;
        }
        const transactions = order.worklog.total / 100;
        if (order.companyId) {
          // console.log('Completed B2B', order.id, monthString, transactions, months[monthString].transactionsB2B);
          months[monthString].completedB2B += 1;
        } else {
          // calculate LT LTV
          if (!order.country || order.country === 'LT') {
            const total = order.worklog.total;
            // console.log('BOO');
            Object.values(months).forEach(month => {
              if (month.cohort.indexOf(order.clientId) !== -1) {
                month.orderLifetimeC2cLt += total;
              }
            });
          }
          months[monthString].completed += 1;
        }
        if (order.companyId) {
          if (order.worklog.currency === 'PLN') {
            months[monthString].revenuePln += revenue;
            months[monthString].transactionsB2BPln += transactions;
          } else {
            months[monthString].revenueB2B += revenue;
            months[monthString].transactionsB2B += transactions;
          }
        } else {
          if (order.worklog.currency === 'PLN') {
            months[monthString].revenuePln += revenue;
            months[monthString].transactionsPln += transactions;
          } else {
            months[monthString].revenue += revenue;
            months[monthString].transactions += transactions;
          }
        }
      }
    });
    pros.forEach(user => {
      if (user.taskerTermsAcceptedAt) {
        const monthString = getMonthString(user.taskerTermsAcceptedAt);
        months[monthString].pros += 1;
      }
    });
    const stats = Object.keys(months).map(key => {
      // console.log(months[key].orderLifetimeC2cLt, months[key].registeredLt, months[key].cohort);
      return {
        month: key,
        revenue: Math.round(months[key].revenue),
        revenuePln: Math.round(months[key].revenuePln),
        registered: months[key].registered,
        registeredContacts: months[key].registeredContacts,
        createdContacts: months[key].createdContacts,
        pros: months[key].pros,
        created: months[key].created,
        completed: months[key].completed,
        transactions: Math.round(months[key].transactions),
        transactionsPln: Math.round(months[key].transactionsPln),
        transactionsB2BPln: Math.round(months[key].transactionsB2BPln),
        completedB2B: months[key].completedB2B,
        revenueB2B: Math.round(months[key].revenueB2B),
        transactionsB2B: Math.round(months[key].transactionsB2B),
        ltvLt: (months[key].registeredLt ? Math.round(months[key].orderLifetimeC2cLt / months[key].registeredLt * 0.2) : 0) / 100
      };
    }).sort((a, b) => {
      return a.month < b.month;
    });
    for (let i = 0; i < stats.length; i++) {
      const stat = stats[i];
      if (stat.created) {
        stat.percentage = Math.round(stat.completed / stat.created * 100);
      } else {
        stat.percentage = 0;
      }
    }
    for (let i = 0; i < stats.length; i++) {
      const stat = stats[i];
      Object.keys(stat).forEach(key => {
        if (i < stats.length - 1 && stats[i + 1][key]) {
          const s1 = stats[i + 1][key];
          const s2 = stat[key];
          const date = new Date();
          const numdays = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
          const s2projected = stat[key] / (date).getDate() * numdays;
          const projectedAmount = Math.round((s2projected - s1) / s1 * 100);
          stat[key + 'Projected'] = projectedAmount < 0 ? projectedAmount + '%' : '+' + projectedAmount + '%';
          if (s1 < s2) {
            stat[key + 'Diff'] = '+' + Math.round((s2 - s1) / s1 * 100) + '%';
            stat[key + 'DiffClass'] = 'positive';
          } else {
            stat[key + 'Diff'] = -Math.round((s1 - s2) / s1 * 100) + '%';
            stat[key + 'DiffClass'] = 'negative';
          }
        } else {
          stat[key + 'Diff'] = 0;
        }
      });
    }
    this.stats = stats;
  },
}
</script>
